import { render, staticRenderFns } from "./UserDepartmentsList.vue?vue&type=template&id=1ba1fda9"
import script from "./UserDepartmentsList.vue?vue&type=script&lang=js"
export * from "./UserDepartmentsList.vue?vue&type=script&lang=js"
import style0 from "./UserDepartmentsList.vue?vue&type=style&index=0&id=1ba1fda9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports